import React from 'react';
import { ConditionsPage } from './pages/ConditionsPage';
export function App() {
  return <ConditionsPage data-id="element-0" />;
}